import { FC } from 'react';
import { Box, Card } from '@mui/material';
import { FormItemDto, FormQuestionDto, FormSectionDto, Building } from '../onsite-visit.dto';
import { QuestionRenderer } from './QuestionRenderer';
import { SectionRenderer } from './SectionRenderer';

interface FormItemRendererProps {
    item: FormItemDto;
    responses: Record<string, string>;
    errors: Record<string, boolean>;
    onResponseChange: (questionId: string, value: string) => void;
    // Building selection props for sections - now per instance
    selectedBuildings?: Building[] | null;
    instanceEntityMap?: Record<string, string[]>;
    onInstanceEntityChange?: (instanceKey: string, entityIds: string[]) => void;
    formatSelectedIds?: (selected: string[], buildings: Building[] | null) => string;
    t?: (key: string) => string;
}

export const FormItemRenderer: FC<FormItemRendererProps> = ({
    item,
    responses,
    errors,
    onResponseChange,
    selectedBuildings,
    instanceEntityMap,
    onInstanceEntityChange,
    formatSelectedIds,
    t,
}) => {
    if (item.type === 'question') {
        const question = item as FormQuestionDto;
        return (
            <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
                <QuestionRenderer
                    question={question}
                    value={responses[question.id] || question.response || ''}
                    onChange={(value) => onResponseChange(question.id, value)}
                    error={errors[question.id]}
                    helperText={errors[question.id] ? 'This field is required' : ''}
                />
            </Card>
        );
    }

    if (item.type === 'section') {
        const section = item as FormSectionDto;
        return (
            <Box sx={{ mb: 2 }}>
                <SectionRenderer
                    section={section}
                    responses={responses}
                    errors={errors}
                    onResponseChange={onResponseChange}
                    selectedBuildings={selectedBuildings}
                    instanceEntityMap={instanceEntityMap}
                    onInstanceEntityChange={onInstanceEntityChange}
                    formatSelectedIds={formatSelectedIds}
                    t={t}
                />
            </Box>
        );
    }

    return null;
};
